// @ts-strict-ignore
import { ArticleVO } from '@article/model/vo/article.vo';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { Vector3 } from 'three';
import { BaseConnectionOperation } from './base-connection-operation';
import { IOperation } from '@shared/undo/operation/i-operation';
import { SceneManager } from '@3d-scene/manager/scene.manager';
import { ConnectionConverter } from '@article/components/connections/connection-creation/connection-converter';
import { ConnectionCreator } from '@article/components/connections/connection-creation/connection-creator';
import { ProjectArticleManager } from '@project/components/article/manager/project-article.manager';
import { SelectionModel } from '@project/components/article/model/selection.model';
import { ProjectModel } from '@project/model/project.model';
import { AdminService } from '../services/admin.service';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';

interface ConnectionPosition {
  position: Vector3;
  rotationDegree: Vector3;
  widthOrRadius: number;
  length: number;
}

export enum MoveConnectionOperationsTypes {
  CHANGE_POSITION = 'changePosition',
  CHANGE_ROTATION = 'changeRotation',
  RESIZE_CONNECTION = 'resizeConnection'
}

export class MoveConnectionOperation extends BaseConnectionOperation implements IOperation {
  private _moveOperationType: string;

  constructor(
    articleContainer: ArticleContainer,
    connection: Connection,
    article: ArticleVO,
    private _oldConnectionPosition: ConnectionPosition,
    private _newConnectionPosition: ConnectionPosition,
    operationType: string,
    adminService: AdminService,
    projectModel: ProjectModel,
    selectionModel: SelectionModel,
    selectionModelService: SelectionModelService,
    sceneManager: SceneManager,
    projectArticleManager: ProjectArticleManager,
    connectionCreator: ConnectionCreator,
    connectionConverter: ConnectionConverter,
    applicationRefreshService: ApplicationRefreshService
  ) {
    super(
      adminService,
      projectModel,
      selectionModel,
      selectionModelService,
      sceneManager,
      projectArticleManager,
      connectionCreator,
      connectionConverter,
      connection,
      articleContainer,
      article,
      applicationRefreshService
    );
    this._moveOperationType = operationType ? operationType : 'description';
  }

  public getQualifiedClassName(): string {
    return 'MoveConnectionOperation';
  }

  public getOperationDescription(): string {
    return `moveConnectionOperation.${this._moveOperationType}`;
  }

  public async performRedo(): Promise<void> {
    this.moveConnectionToPosition(this._newConnectionPosition);
  }

  public async performUndo(): Promise<void> {
    this.moveConnectionToPosition(this._oldConnectionPosition);
  }
}
